export default {
  title: {
    create: 'Nový virtuálny signál',
    edit: 'Nastavenia signálu',
  },
  tabs: {
    signal: 'Nastavenia virtuálneho signálu',
    preset: 'Predvoľby',
    metadata: 'Nastavenia signálu',
  },
};
